import styled from 'styled-components'

import {VariantDetail} from '@festi/common/api/rest'
import {CloseButton} from '@festi/common/components/buttons'
import {styledTheme} from '@festi/common/themes'
import {AugmentedUserPrice} from '@festi/common/utils/rest'

import HorizontalProductCard from 'src/components/cards/redesign/HorizontalProductCard'

const ItemRoot = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${styledTheme.palette.ui10Solid};
  &:last-child {
    border-bottom: none;
    padding-bottom: 0px;
  }
`

const RemoveButtonWrapper = styled.div`
  transform: translate(8px, -8px);
`

interface CompareItemProps {
  variant: VariantDetail
  onClickRemove: (sku: string) => void
  position: number
  userPrice: AugmentedUserPrice
}

export default function CompareDrawerItem({
  variant,
  onClickRemove,
  position,
  userPrice,
}: CompareItemProps) {
  return (
    <ItemRoot>
      <HorizontalProductCard
        image={{
          url: variant.images?.[0]?.image.webpXs,
          jpg: variant.images?.[0]?.image.jpgXs,
          alt: variant.images?.[0]?.alt,
        }}
        variant={variant}
        origin="compare-drawer"
        position={position}
        userPrice={userPrice}
        small
      />
      <RemoveButtonWrapper>
        <CloseButton onClick={() => onClickRemove(variant.sku)} />
      </RemoveButtonWrapper>
    </ItemRoot>
  )
}
